export interface AuthFooterLink {
  label: string
  href: string
}

export const AUTH_FOOTER_LINK_LIST: AuthFooterLink[] = [
  { label: 'Help', href: 'https://saagasolve.com/help-center' },
  { label: 'Privacy', href: 'https://saagasolve.com/legal/privacy-policy' },
  { label: 'Terms', href: 'https://saagasolve.com/legal/terms-of-use' },
]
